<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            My Sessions Drawer
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="mysessionConfig.isSessionEnabled ? 'Enable' : 'Disable'"
            [isChecked]="mysessionConfig.isSessionEnabled"
            (isCheckedChange)="toggleSessionEnabled($event)"
            >{{ mysessionConfig.isSessionEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="mysessionConfig.isSessionEnabled == true">
    <div class="mysession-drawer">
        <div class="c-title--subsection text-uppercase">
            Drawer Control
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="control c-box" (cclClick)="openConfigDrawer('drawer-control', $event, 'drawer-control')"
                    title="Edit Drawer Control">
                    <i title="Cart"
                        class="fa fa-lg"
                        [ngClass]="mysessionConfig.drawer_button.icon"
                        [ngStyle]="{
                            color: mysessionConfig.drawer_button.color,
                            background: mysessionConfig.drawer_button.background
                        }"
                    ></i>
                </div>
                <p class="control-note">
                    NOTE: This element will be placed directly below the Header on the right hand side of the screen and
                    scroll with the page to be continually accessible.
                </p>
            </div>
        </div>

        <div class="c-title--subsection text-uppercase">
            Drawer
        </div>
        <div class="row row--builder">
            <div class="col c-box" [class.c-box]="!hoverOut" [class.c-box-nohover]="hoverOut">
                <div
                    class="c-box" title="Edit Drawer Header"
                    (cclClick)="openConfigDrawer('header', $event, 'header')"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                >
                    <h3
                        class="header"
                        [ngStyle]="{
                            background: mysessionConfig.header.background
                        }"
                    >
                        <i
                            class="fa fa-lg"
                            [ngClass]="mysessionConfig.drawer_button.icon"
                            [ngStyle]="{
                                color: mysessionConfig.drawer_button.color
                            }"
                        ></i>
                        <span [ngStyle]="fontstyle">
                            {{ mysessionConfig.header.label }}
                        </span>
                    </h3>
                </div>

                <div class="c-box" (mouseout)="hoverOut = false" (mouseover)="hoverOut = true"
                    (cclClick)="openConfigDrawer('tabs', $event, 'tabs')" title="Edit Drawer Tabs">
                    <div class="pull-left text-center">
                        <div class="tab-data">
                            <div
                                class="tab-element active"
                                [ngStyle]="{
                                    color: mysessionConfig.tabConfig.activeLabelColor,
                                    margin: '5px',
                                    'border-bottom-color': mysessionConfig.tabConfig.activeBorderColor,
                                    'border-bottom-style': mysessionConfig.tabConfig.borderStyle,
                                    background: 'none'
                                }"
                            >
                                Selected
                            </div>
                        </div>
                    </div>
                    <div class="pull-left text-center">
                        <div class="tab-data">
                            <div
                                class="tab-element"
                                [ngStyle]="{
                                    color: mysessionConfig.tabConfig.inactiveLabelColor,
                                    margin: '5px',
                                    'border-bottom-color': mysessionConfig.tabConfig.inactiveBorderColor,
                                    'border-bottom-style': mysessionConfig.tabConfig.borderStyle,
                                    background: 'none'
                                }"
                            >
                                Background
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>

                <div class="mysession-drawer-body">
                    <div
                        class="layout-box"
                        [ngStyle]="{
                            'background-color': mysessionConfig.catalogConfig.header.textConfig.background,
                            margin: mysessionConfig.catalogConfig.header.regionConfig.margin,
                            padding: mysessionConfig.catalogConfig.header.regionConfig.padding,
                            'border-radius': mysessionConfig.catalogConfig.header.regionConfig.corner
                        }"
                    >
                        <div class="row mar-right0">
                            <div class="col-sm-12 col-xs-12">
                                <div
                                    class="editable text w100" title="Edit Session Template"
                                    (cclClick)="openConfigDrawer('html', $event, 'header')"
                                    (mouseout)="hover = false; hoverOut = false"
                                    (mouseover)="hover = true; hoverOut = true"
                                >
                                    <div class="text-info text-content-collapsed">
                                        <div
                                            class="text-content"
                                            [innerHTML]="headerLayout | safeHtml"
                                            [ngStyle]="{
                                                position: 'relative',
                                                'word-wrap': 'break-word',
                                                'background-color':
                                                    mysessionConfig.catalogConfig.header.textConfig.background,
                                                color: mysessionConfig.catalogConfig.header.textConfig.textColor
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                </div>
                <div class="mysession-drawer-footer c-box" (mouseout)="hoverOut = false" (mouseover)="hoverOut = true">
                    <button
                        class="c-btn c-btn--primary"
                        [ngStyle]="{
                            'background-color': mysessionConfig.button.primary.background,
                            color: mysessionConfig.button.primary.color
                        }"
                    >
                        Add to Schedule
                    </button>
                    <button
                        class="c-btn c-btn--secondary"
                        [ngStyle]="{
                            'background-color': mysessionConfig.button.secondary.background,
                            color: mysessionConfig.button.secondary.color
                        }"
                    >
                        Remove All
                    </button>
                </div>
            </div>
        </div>

        <div class="c-title--subsection text-uppercase">
            Select payments form
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="c-box">
                    <div class="c-form-group">
                        <ccl-simple-select ariaLabel="Select payments form"
                            [listOfItems]="forms"
                            (valueChange)="changeForm($event.value); mysessionConfig.formId = $event.value"
                            [value]="mysessionConfig.formId"
                            [bindValue]="'id'"
                            [bindLabel]="'name'"
                        ></ccl-simple-select>
                        <div class="c-form-group__hint">&nbsp;</div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>

<!-- My schedule  -->

<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            My Schedule Drawer
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="mysessionConfig.my_schedule.isScheduledEnabled ? 'Enable' : 'Disable'"
            [isChecked]="mysessionConfig.my_schedule.isScheduledEnabled"
            (isCheckedChange)="toggleSchduleEnabled($event)"
            >{{ mysessionConfig.my_schedule.isScheduledEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="mysessionConfig.my_schedule.isScheduledEnabled == true">
    <div class="mysession-drawer">
        <div class="c-title--subsection text-uppercase">
            Calendar Control
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="control c-box" (cclClick)="openConfigDrawer('calendar-control', $event, 'calendar-control')"
                    title="Edit Calendar Control">
                    <i title="Cart"
                        class="fa fa-lg"
                        [ngClass]="mysessionConfig?.my_schedule?.my_schedule_drawer_button?.icon || 'fa-calendar'"
                        [ngStyle]="{
                            color: mysessionConfig.my_schedule.my_schedule_drawer_button.color,
                            background: mysessionConfig.my_schedule.my_schedule_header.background
                        }"
                    ></i>
                </div>
            </div>
        </div>

        <div class="c-title--subsection text-uppercase">
            Drawer
        </div>
        <div class="row row--builder">
            <div class="col c-box" [class.c-box]="!hoverOut" [class.c-box-nohover]="hoverOut">
                <div
                    class="c-box" title="Edit Drawer Header"
                    (cclClick)="openConfigDrawer('myschedule-header', $event, 'header')"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                >
                    <h3
                        class="header"
                        [ngStyle]="{
                            background: mysessionConfig.my_schedule.my_schedule_header.background
                        }"
                    >
                        <i
                            class="fa fa-lg"
                            [ngClass]="mysessionConfig.my_schedule.my_schedule_drawer_button.icon"
                            [ngStyle]="{
                                color: mysessionConfig.my_schedule.my_schedule_drawer_button.color
                            }"
                        ></i>
                        <span [ngStyle]="myschedulefontstyle">
                            {{ mysessionConfig?.my_schedule?.my_schedule_header?.label }}
                        </span>
                    </h3>
                </div>

            </div>
        </div>
    </div>
</ccl-content-section>

